export const formatFechaEnvioBD = (p_fecha) => {
  const fecha = new Date(p_fecha);

  // Formatea la fecha en el formato deseado
  const fechaFormateada = `${fecha
    .getFullYear()
    .toString()
    .padStart(4, "0")}-${(fecha.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${fecha.getDate().toString().padStart(2, "0")}T${fecha
    .getHours()
    .toString()
    .padStart(2, "0")}:${fecha.getMinutes().toString().padStart(2, "0")}:${fecha
    .getSeconds()
    .toString()
    .padStart(2, "0")}`;

  return fechaFormateada;
};
